import { COUNTRY_CODE_EE, COUNTRY_CODE_LT, COUNTRY_CODE_LV } from "../constants";

const getCountryCodeByLocale = (locale: string): string => {
  const countryCodesMap = {
    lt: COUNTRY_CODE_LT,
    lv: COUNTRY_CODE_LV,
    ee: COUNTRY_CODE_EE,
  };
  return countryCodesMap[locale] || "";
};
export default getCountryCodeByLocale;
